import { Link } from 'react-router-dom';
import { blogArticles } from '@/mocks/blogArticles';

export default function BlogPreviewSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-primary-500 tracking-widest uppercase mb-3">
            PandabuySpreadsheet Blog
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Latest <span className="text-primary-500">Shopping Guides</span>
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            Expert insights, tutorials, and strategies to help you master product comparison
            and make smarter purchasing decisions with structured data.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {blogArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              {/* Article Image */}
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-white/90 text-foreground-800 text-[10px] font-semibold px-2 py-0.5 rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>

              {/* Article Content */}
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
                  <span>{article.readTime}</span>
                  <span>&middot;</span>
                  <span>{new Date(article.datePublished).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-sm font-semibold text-primary-500 group-hover:text-primary-600 transition-colors">
                  Read Article
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-xs text-foreground-400">
            More articles coming soon — bookmark this page for the latest PandabuySpreadsheet shopping guides.
          </p>
        </div>
      </div>
    </section>
  );
}